import React from 'react';
import * as styles from './styles.scss';

interface BackgroundAnglesProps {
  environment: 'dark' | 'light';
}

const BackgroundAngles = ({ environment }: BackgroundAnglesProps) => (
  <div className={`${styles.angles} ${environment === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
    <svg
      className={styles.mainAngle}
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 1024">
      <g
        fill={environment === 'dark' ? 'rgba(25, 31, 36, 1)' : 'rgba(242, 245, 247, 1)'}
        fillRule="evenodd"
        transform="translate(-66 -99)">
        <polygon points="622.491263 91 1717.76503 91 1119.27377 1123 24 1123" />
        <polygon points="1775.49126 3.32267547e-12 2870.76503 0 2272.27377 1032 1177 1032" />
        <polygon points="294.026231 624 679.930233 624 385.904002 1131 0 1131" />
      </g>
    </svg>
  </div>
);

export default BackgroundAngles;
